import React, { createContext, ReactNode, useState, Dispatch, SetStateAction, useContext } from 'react';
import LoadingSpinner from 'src/components/common/LoadingSpinner';

type ProgressbarContextType = {
    show: boolean;
    setShow: Dispatch<SetStateAction<boolean>>;
};

const ProgressbarContext = createContext<ProgressbarContextType | undefined>(undefined);

interface Props {
    children: ReactNode; // ReactNode 타입을 사용하여 모든 종류의 자식을 수용할 수 있도록 함
}

export function ProgressbarProvider({ children }: Props): JSX.Element {
    const [show, setShow] = useState<boolean>(false);

    return (
        <ProgressbarContext.Provider value={{ show, setShow }}>
            {show && <LoadingSpinner />}
            {children}
        </ProgressbarContext.Provider>
    );
}

export function useProgressBarState(): ProgressbarContextType {
    const state = useContext(ProgressbarContext);
    if (!state) throw new Error('ProgressbarProvider not found');
    return state;
}
